import React, { useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import BaseHeader from "@/components/Common/BaseHeader";
import { useUserDetails } from "@/contextApi";
import { pageURLs } from "@/constants";
import Home from "@/images/v2/Home-icon.svg";
import Inventory from "@/images/v2/Inventory.svg";
import Help from "@/images/v2/Help-icon.svg";
import { BaseSidebarWrapper, HeaderSidebarBaseWrapper, SidebarItem } from "./HeaderSidebar";

const Sidebar = ({ currentURL, handleGoHelp, handleGoInventory, handleGoFeed, shouldToggleColor }) => {

  return (
    <BaseSidebarWrapper shouldToggleColor={shouldToggleColor}>
      <SidebarItem
        label="Feed"
        icon={Home}
        onClick={handleGoFeed}
        isActive={currentURL === "/" || currentURL === pageURLs.home}
      />

      <SidebarItem
        icon={Inventory}
        label={"My Inventory"}
        isActive={currentURL === pageURLs.consumerInventoryListing}
        onClick={handleGoInventory}
      />

      <SidebarItem icon={Help} label={"Help/Tutorials"} onClick={handleGoHelp} />
    </BaseSidebarWrapper>
  );
};

const HeaderSidebarConsumer = React.forwardRef((allProps, headerRef) => {

  const {
    headerHeight,
    handleAgentOnboardingModal,
    handleGoFeed,
    user,
    currentURL,
    userPlan,
    showAgentMenuNotificationIcon,
    handleGoHelp,
    handleGoInventory,
    goTo,
    handleLogOut,
  } = allProps;

  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const [contactModalState, setContactModalState] = useState(false);

  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const ContactModalShow = () => setContactModalState(true);

  const navigate = useNavigate();

  const userDetails = useUserDetails();

  const headerContent = HeaderSidebarBaseWrapper({
    ...allProps,
    sidebar: <Sidebar
      currentURL={currentURL}
      headerHeight={headerHeight}
      handleGoHelp={handleGoHelp}
      handleGoInventory={handleGoInventory}
      handleAgentOnboardingModal={handleAgentOnboardingModal}
      handleGoFeed={handleGoFeed}
      goTo={goTo}
      user={user}
      shouldToggleColor={userDetails?.shouldToggleColor}
      BasicPlanModalShow={BasicPlanModalShow}
      ContactModalShow={ContactModalShow}
    />,
    authButtonsProps: {
      handleAgentOnboardingModal,
    },
    headerSidebarDropdownMenuProps: {
      user,
      userDetails,
      userPlan,
      showAgentMenuNotificationIcon,
      navigate,
      BasicPlanModalShow,
      ContactModalShow,
      handleLogOut,
    }
  })

  return (
    <BaseHeader
      {...allProps}
      headerContent={headerContent}
    />
  );
});

export default HeaderSidebarConsumer;
